import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import 'vuetify/src/stylus/app.styl'
import colors from 'vuetify/es5/util/colors'

Vue.use(Vuetify, {
  iconfont: 'md',
  theme: {
    primary: '#707070',
    grey: {
		base: '#707070',
		lighten1: '#989898',
		lighten3: 'rgba(112, 112, 112, .2)'
	},
		pink: '#ffe8e8',
		blue: {
		base: '#5c97ba',
		darken1: '#245DBF'
	},
		green: '#2DD573',
		black: {
		base: '#000',
		lighten1: '#373B47'
	}
  }
})
